var pageTypeMatches = /route-([a-zA-Z]+)/.exec(document.body.className);

if (pageTypeMatches !== null) {
    window.pageType = pageTypeMatches[1];
}

window.Debug = document.body.classList.contains('debug');

if (Debug) {
    console.log(window.pageType);
}

window.MasterSite = document.body.classList.contains('master');

window.getIsMasterSite = function () {
    return MasterSite;
};

if (!('contains' in String.prototype)) {
    String.prototype.contains = function (str, startIndex) {
        return -1 !== String.prototype.indexOf.call(this, str, startIndex);
    };
}

if (!String.prototype.endsWith) {
    Object.defineProperty(String.prototype, 'endsWith', {
        value: function (searchString, position) {
            var subjectString = this.toString();
            if (position === undefined || position > subjectString.length) {
                position = subjectString.length;
            }
            position -= searchString.length;
            var lastIndex = subjectString.indexOf(searchString, position);
            return lastIndex !== -1 && lastIndex === position;
        }
    });
}

window.$ = window.jQuery = require('jquery');

if (typeof(window.Laravel) != 'undefined') {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': window.Laravel.csrfToken
        }
    });
}

$.fn.hasAttr = function (name) {
    return this.attr(name) !== undefined;
};

function Generator(){}
Generator.prototype.rand = Math.floor(Math.random() * 26) + Date.now();
Generator.prototype.getId = function () {
    return this.rand++;
};

var idGen = new Generator();
$.fn.generateID = function () {
    this.attr('id', idGen.getId());
    this.attr('id');
};

window.$body = $('body');

import MobileCartWidget from './mobilecartwidget.js';
window.mobileCartWidget = new MobileCartWidget();

require('./sliders');

require('./formsHandler');

require('../semantic/dist/semantic.js');

require('./scrolls');

require('./move-to');

require('./calculate_delivery');

switch (pageType) {
    case 'ProductCategory':
    case 'ProductCategoryCommon':
        if ($('.widget_product_params').length) {
            window.parameters = require('./parameters');
            require('./nanesenieButtons');
        }
        // if (!parseInt($body.data('isMobile')) && !(parseInt($body.data('page')) > 1)) {
        //    /*require('jquery-ias');
        //
        //     var ias = jQuery.ias({
        //     container:  '#shop-posts-list',
        //     item:       'article',
        //     pagination: 'div.pagination',
        //     next:       'div.pagination a.next'
        //     });
        //
        //     ias.extension(new IASSpinnerExtension());*/
        // }
        require('./productcategorypage');
        break;
    case 'ProductProduct':
    case 'ProductProductCommon':
        if (($body.data('categoryId') == '13' || $body.data('categoryId') == '114211')) {
            require('./nanesenie');
        }
        if (pageType == 'ProductProductCommon') {
            require('./interactive_parameters/product_page_interactive_parameters');
        }
        require('./productacessories');
        require('./productpage');
        break;
    case 'CheckoutCart':
        require('./maps');
        break;
    case 'CheckoutOform':
        require('./checkout/oformpage');
        require('./calculate_delivery');
        break;
    case 'InformationContact':
        // require('./maps');
        // jQuery.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyA0slBvCpxDu6vt2j9w0JUJ5Vy0gExFxYM&sensor=false&callback=initializeGoogleMap');
        break;
    case 'InformationInformation':
        if ($body.data('informationId') == '10041') {
            require('./fleshkioptom.js');
        }
        break;
}

if (pageType.endsWith('Common')
       && pageType !== 'ProductProductCommon'
           && $('.post-content .ui.table tbody, .capacities-table tbody').length) {
    require('./commoncolors');
}

(function ($) {
    $(document).ready(function () {
        require('./common');
    });
    window.onload = function () {
        $('link[media="none"]').attr('media', 'all');
    }
})(jQuery);

require('./addproducttocart');

require('./yandex-autologin');



// WEBPACK FOOTER //
// ./assets/javascript/app.js